const FilterActions = {
    UPDATE_FILTER: 'UPDATE_FILTER',
    SHOW_FILTER: 'SHOW_FILTER',
    HIDE_FILTER: 'HIDE_FILTER',
    SHOW_FILTER_SECTION: 'SHOW_FILTER_SECTION',
    HIDE_FILTER_SECTION: 'HIDE_FILTER_SECTION',
    ENABLE_OPTION: 'ENABLE_OPTION',
    DISABLE_OPTION: 'DISABLE_OPTION',
    SHOW_MOBILE_FILTERS: 'SHOW_MOBILE_FILTERS',
    HIDE_MOBILE_FILTERS: 'HIDE_MOBILE_FILTERS',
    SET_APPLY_TO_EXPLICIT: 'SET_APPLY_TO_EXPLICIT',
    SET_APPLY_TO_IMPLICIT: 'SET_APPLY_TO_IMPLICIT',
    SET_PROVISIONAL_FILTER: 'SET_PROVISIONAL_FILTER',
    SET_PROVISIONAL_SECTION_FILTER: 'SET_PROVISIONAL_SECTION_FILTER',
    OPEN_FILTER_SECTION: 'OPEN_FILTER_SECTION',
    OPEN_LIGHTBOX_FILTER_SECTION: 'OPEN_LIGHTBOX_FILTER_SECTION',
    CLOSE_LIGHTBOX_FILTER_SECTION: 'CLOSE_LIGHTBOX_FILTER_SECTION',
};

export { FilterActions };